<template>
  <section class="new-password">
    <div class="main-header">
      <h2 class="subscribe-title">{{ $t('login.register_new_password') }}</h2>
      <h3 class="subscribe-subtitle">{{ $t('login.type_new_password_for_your_account') }}</h3>
    </div>
    <div class="reset-password-container login-box">
      <flash-message></flash-message>
      <h1 class="ls-login-logo">
        <img src="./../../../assets/img/logo.svg" width="140">
      </h1>

      <form class="ls-form row" role="form" @submit.prevent="validateBeforeSubmit">

        <fieldset class="ls-md-margin-bottom">

          <label class="ls-label" :class="{'ls-error': errors.has($t('login.new_password')) }">
            <b class="ls-label-text ls-hidden-accessible">{{ $t('login.attributes.password') }}</b>
            <div class="ls-prefix-group">
              <span class="ls-label-text-prefix"><i class="fa fa-lock" aria-hidden="true"></i></span>
              <input
                id="password"
                type="password"
                v-model="password"
                v-validate="'required'"
                :placeholder="$t('login.placeholder.new_password')"
                :name="$t('login.new_password')" />
              <span class="ls-label-text-prefix ls-toggle-pass ls-ico-eye" data-toggle-class="ls-ico-eye, ls-ico-eye-blocked" data-target="#password" href="javascript:void(0)"></span>
            </div>
            <small v-show="errors.has($t('login.new_password'))" class="ls-help-message">{{ errors.first($t('login.new_password')) }}</small>
          </label>

          <label class="ls-label" :class="{'ls-error': errors.has($t('login.confirm_password')) }">
            <b class="ls-label-text ls-hidden-accessible">{{ $t('login.attributes.confirm_password') }}</b>
            <div class="ls-prefix-group">
              <span class="ls-label-text-prefix"><i class="fa fa-lock" aria-hidden="true"></i></span>
              <input
                type="password"
                v-model="passwordConfirmation"
                v-validate="'required|confirmed:' + $t('login.new_password')"
                :placeholder="$t('login.placeholder.confirm_password')"
                :name="$t('login.confirm_password')" />
              <i class="fa" aria-hidden="true" :class="{ 'fa-check': passwordConfirmation && !errors.first($t('login.confirm_password')) }"></i>
            </div>
            <span v-show="errors.has($t('login.confirm_password'))" class="ls-help-message">{{ errors.first($t('login.confirm_password')) }}</span>
          </label>

        </fieldset>

        <button class="ls-btn-primary ls-btn-block ls-btn-lg ls-full-width ls-md-margin-bottom">{{ $t('application.reset_password.new_password') }}</button>
        <p class="ls-md-margin-bottom ls-txt-center">{{ $t('login.attributes.go_to_link') }} <br /> <router-link :to="{ name: 'auth'}" :title="$t('login.signin')">{{ $t('login.signin') }}</router-link> {{ $t('login.attributes.or') }} <router-link :to="{ name: 'signup'}" :title="$t('login.no_register')">{{ $t('login.register_now') }}</router-link></p>
      </form>

    </div>
  </section>
</template>
<script>
  import { mapMutations, mapActions } from 'vuex'

  export default {
    data () {
      return {
        password: '',
        passwordConfirmation: '',
        loading: false
      }
    },
    methods: {
      ...mapActions(['editPassword']),
      ...mapMutations(['clearFlash', 'setKeepFlash']),
      validateBeforeSubmit () {
        this.clearFlash()
        this.$validator.validateAll().then(this.afterValidate)
      },
      afterValidate (success) {
        if (!success) return
        this.$loader.show()
        const args = { reset_password_token: this.$route.params.reset_password_token, password: this.password, password_confirmation: this.passwordConfirmation }
        this.editPassword(args).then(this.afterUpdate)
      },
      afterUpdate (response) {
        this.setKeepFlash(true)
        this.$loader.hide()
        if (response.status !== 422) this.$router.push('/auth')
      },
      passwordMatch () {
        return this.password === this.passwordConfirmation && this.password !== ''
      }
    }
  }
</script>
<style lang="scss" scoped>
  .new-password {
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    left: 0;
    padding: 20px;
    width: 100%;
    margin: 0 auto;
    background-color: #f7f7f7;
    .main-header {
      padding: 1.2em 0;
    }
    .subscribe-title {
      text-align: center;
      color: rgb(110, 118, 141);
      font-size: 300%;
      margin-bottom: 20px;
      letter-spacing: 0.04em;
    }
    .subscribe-subtitle {
      margin-bottom: 30px;
      color: #b4bdc6;
      font-size: 1.8em;
      font-weight: normal;
      letter-spacing: 0.04em;
      text-align: center;
    }
    .title-intro {
      border-bottom: 1px solid #e5e5e5;
      margin-bottom: 40px;
      padding-top: 20px;
    }
    .reset-password-container {
      width: 300px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      background-color: white;
      padding: 20px;
      margin: 20px auto;
    }
    .ls-login-logo {
      margin-bottom: 40px;
      img {
        margin: 0 auto;
        display: block;
      }
    }
    form {
      margin: 0 auto;
      input#password {
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        border-right: none;
      }
      label {
        i.fa.fa-check::before {
          position: absolute;
          margin: -5px -25px;
          z-index: 99;
          color: #72c18e;
        }
        i.fa.fa-times::before {
          position: absolute;
          margin: -5px -25px;
          z-index: 99;
          color: #fb7070;
        }
      }
      .ls-error {
        .ls-prefix-group .ls-label-text-prefix {
          color: #d75553!important;
          border-color: #d75553!important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// NewPassword.vue?f98d09dc